import { Box, styled } from '@mui/material';
export const EventItem = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'add_pointer',
})(({ theme, add_pointer }) => ({
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '&:not(:last-child)': {
        borderBottom: '1px solid #B1B1B1',
        paddingBottom: 8,
    },
    '&:hover, &.Mui-focusVisible': {
        backgroundColor: theme.palette.mode === 'dark' ? '#212121' : '#d8d8d8',
        cursor: add_pointer ? 'pointer' : 'auto',
    },
    padding: 8,
    borderRadius: 4,
    minHeight: 57,
}));
